<template>
  <div class="input-wrapper">
    <input
      :type="showPassword ? 'text' : 'password'"
      id="password"
      v-model="value"
      @input="this.$emit('update:password', $event.target.value);"
    />
    <button type="button" @click="togglePasswordVisibility">
        <svg v-if="!showPassword" width="20.000000" height="20.000000" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
            <defs>
                <clipPath id="clip10_949">
                    <rect id="Icons" rx="0.000000" width="19.000000" height="19.000000" transform="translate(0.500000 0.500000)" fill="white" fill-opacity="0"/>
                </clipPath>
            </defs>
            <rect id="Icons" rx="0.000000" width="19.000000" height="19.000000" transform="translate(0.500000 0.500000)" fill="#FFFFFF" fill-opacity="0"/>
            <g clip-path="url(#clip10_949)">
                <path id="Vector" d="M17.5 11.25C17.5 8.88 14.14 5.41 10 5.41C5.85 5.41 2.5 8.88 2.5 11.25C2.5 13.61 5.85 17.08 10 17.08C14.14 17.08 17.5 13.61 17.5 11.25Z" stroke="#131A29" stroke-opacity="1.000000" stroke-width="1.250000" stroke-linejoin="round"/>
                <path id="Vector" d="M12.5 11.25C12.5 9.86 11.38 8.75 10 8.75C8.61 8.75 7.5 9.86 7.5 11.25C7.5 12.63 8.61 13.75 10 13.75C11.38 13.75 12.5 12.63 12.5 11.25Z" stroke="#131A29" stroke-opacity="1.000000" stroke-width="1.250000" stroke-linejoin="round"/>
                <path id="Vector" d="M5.52 4.69L6.6 6.2" stroke="#131A29" stroke-opacity="1.000000" stroke-width="1.250000" stroke-linecap="round"/>
                <path id="Vector" d="M14.84 4.87L13.76 6.38" stroke="#131A29" stroke-opacity="1.000000" stroke-width="1.250000" stroke-linecap="round"/>
                <path id="Vector" d="M10 2.91L10 5.41" stroke="#131A29" stroke-opacity="1.000000" stroke-width="1.250000" stroke-linecap="round"/>
            </g>
        </svg>
        <svg v-if="showPassword" width="20.000000" height="20.000000" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
            <defs>
                <clipPath id="clip10_949">
                    <rect id="Icons" rx="0.000000" width="19.000000" height="19.000000" transform="translate(0.500000 0.500000)" fill="white" fill-opacity="0"/>
                </clipPath>
            </defs>
            <rect id="Icons" rx="0.000000" width="19.000000" height="19.000000" transform="translate(0.500000 0.500000)" fill="#FFFFFF" fill-opacity="0"/>
            <g clip-path="url(#clip10_949)">
                <path id="Vector" d="M17.5 11.25C17.5 8.88 14.14 5.41 10 5.41C5.85 5.41 2.5 8.88 2.5 11.25C2.5 13.61 5.85 17.08 10 17.08C14.14 17.08 17.5 13.61 17.5 11.25Z" stroke="#131A29" stroke-opacity="1.000000" stroke-width="1.250000" stroke-linejoin="round"/>
                <path id="Vector" d="M12.5 11.25C12.5 9.86 11.38 8.75 10 8.75C8.61 8.75 7.5 9.86 7.5 11.25C7.5 12.63 8.61 13.75 10 13.75C11.38 13.75 12.5 12.63 12.5 11.25Z" stroke="#131A29" stroke-opacity="1.000000" stroke-width="1.250000" stroke-linejoin="round"/>
                <path id="Vector" d="M5.52 4.69L6.6 6.2" stroke="#131A29" stroke-opacity="1.000000" stroke-width="1.250000" stroke-linecap="round"/>
                <path id="Vector" d="M14.84 4.87L13.76 6.38" stroke="#131A29" stroke-opacity="1.000000" stroke-width="1.250000" stroke-linecap="round"/>
                <path id="Vector" d="M10 2.91L10 5.41" stroke="#131A29" stroke-opacity="1.000000" stroke-width="1.250000" stroke-linecap="round"/>
            </g>
        </svg>
    </button>


  </div>
</template>

<script>
export default {
props: {
  password: String,
},
data() {
  return {
    value: '',
    showPassword: false,
  };
},
methods: {
  togglePasswordVisibility() {
    this.showPassword = !this.showPassword;
  },
}
};
</script>

<style scoped>
input{
box-sizing: border-box;
border: 1px solid rgb(222, 230, 234);
border-radius: 8px;
background: rgb(255, 255, 255);
height: 44px;
padding-left: 10px;
width: 100%;
}
input:focus {
outline: none;/* если border тоже нужно убрать */
}
.input-wrapper.error input{
border: 1px solid red;
}
.input-wrapper {
position: relative;
}
button {
position: absolute;
right: 11px;
top: 0;
height: 100%;
border: none;
background: transparent;
cursor: pointer;
}
</style>